import React from 'react';
import './DisputesTableSkeleton.css';

const DisputesTableSkeleton = () => {
  const rows = Array.from({ length: 10 });

  return (
    <div className="disputes-table-skeleton">
      <div className="disputes-table-skeleton-thead">
        <div className="disputes-table-skeleton-th" />
        <div className="disputes-table-skeleton-th" />
        <div className="disputes-table-skeleton-th" />
        <div className="disputes-table-skeleton-th" />
        <div className="disputes-table-skeleton-th" />
        <div className="disputes-table-skeleton-th" />
        <div className="disputes-table-skeleton-th" />
        <div className="disputes-table-skeleton-th" />
      </div>
      <div className="disputes-table-skeleton-tbody">
        {rows.map((_, idx) => (
          <div className="disputes-table-skeleton-tr" key={idx}>
            <div className="disputes-table-skeleton-td">
              <div className="disputes-table-skeleton-line sm" />
            </div>
            <div className="disputes-table-skeleton-td">
              <div className="disputes-table-skeleton-line md" />
            </div>
            <div className="disputes-table-skeleton-td">
              <div className="disputes-table-skeleton-badge" />
            </div>
            <div className="disputes-table-skeleton-td">
              <div className="disputes-table-skeleton-badge" />
            </div>
            <div className="disputes-table-skeleton-td">
              <div className="disputes-table-skeleton-line sm" />
            </div>
            <div className="disputes-table-skeleton-td">
              <div className="disputes-table-skeleton-line lg" />
            </div>
            <div className="disputes-table-skeleton-td">
              <div className="disputes-table-skeleton-line xs" />
            </div>
            <div className="disputes-table-skeleton-td">
              <div className="disputes-table-skeleton-badge" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DisputesTableSkeleton;
